<div class="policy-reader-container">
  <app-modal-header-ui [title]="policy.title" (closeModal)="close()"></app-modal-header-ui>

  <!-- Policy context -->
  <div class="reader-header">
    <div class="header-badges">
      <span class="category-badge">{{ policy.category }}</span>
      <span class="version-badge">{{ policy.version }}</span>
      <span class="status-badge">{{ policy.status | titlecase }}</span>
    </div>
    <h1 class="print-policy-title">{{ policy.title }}</h1>
  </div>

  <!-- Metadata Section -->
  <div class="reader-metadata">
    <div class="metadata-item">
      <mat-icon>person</mat-icon>
      <div>
        <span class="metadata-label" i18n="@@author">Author:</span>
        <span class="metadata-value">{{ policy.author }}</span>
      </div>
    </div>
    <div class="metadata-item">
      <mat-icon>schedule</mat-icon>
      <div>
        <span class="metadata-label" i18n="@@lastUpdated">Last Updated:</span>
        <span class="metadata-value">{{ formatDate(policy.lastUpdated) }}</span>
      </div>
    </div>
    <div class="metadata-item" *ngIf="policy.effectiveDate">
      <mat-icon>event</mat-icon>
      <div>
        <span class="metadata-label" i18n="@@effectiveDate">Effective Date:</span>
        <span class="metadata-value">{{ formatDate(policy.effectiveDate) }}</span>
      </div>
    </div>
    <div class="metadata-item">
      <mat-icon>business</mat-icon>
      <div>
        <span class="metadata-label" i18n="@@appliesTo">Applies To:</span>
        <span class="metadata-value">{{ policy.appliesTo }}</span>
      </div>
    </div>
  </div>

  <!-- Acknowledgment Status (if already acknowledged) -->
  <div class="acknowledgment-status" *ngIf="isAcknowledged && acknowledgedAt">
    <mat-icon>check_circle</mat-icon>
    <div>
      <h3 i18n="@@acknowledged">Acknowledged</h3>
      <p>
        <span i18n="@@youAcknowledgedOn">You acknowledged this policy on</span>
        {{ formatDate(acknowledgedAt) }}
      </p>
    </div>
  </div>

  <!-- Reader Body -->
  <div class="reader-body">
    <!-- Executive Summary -->
    <div class="summary-section">
      <h2 i18n="@@executiveSummary">Executive Summary</h2>
      <p class="summary-text">{{ policy.summary }}</p>
    </div>

    <!-- Key Takeaways -->
    <div class="takeaways-section" *ngIf="policy.keyTakeaways && policy.keyTakeaways.length > 0">
      <h2 i18n="@@keyTakeaways">Key Takeaways</h2>
      <ul class="takeaways-list">
        <li *ngFor="let takeaway of policy.keyTakeaways">{{ takeaway }}</li>
      </ul>
    </div>

    <!-- Full Content -->
    <div class="content-section">
      <div class="content-body" [innerHTML]="contentHtml"></div>
    </div>

    <!-- Digital Signature (if acknowledged) -->
    <div class="signature-section" *ngIf="isAcknowledged && acknowledgedAt">
      <h3 i18n="@@digitalSignature">Digital Signature</h3>
      <div class="signature-box">
        <p><strong i18n="@@digitally AcknowledgedBy">Digitally Acknowledged By:</strong></p>
        <p>{{ staffName }}</p>
        <p>{{ staffEmail }}</p>
        <p><strong i18n="@@acknowledgedOn">Acknowledged On:</strong> {{ formatDate(acknowledgedAt) }}</p>
        <p><strong i18n="@@policyVersion">Policy Version:</strong> {{ policy.version }}</p>
      </div>
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="reader-footer">
    <div class="footer-actions-left">
      <app-button-icon-ui
        buttonType="button"
        icon="content_copy"
        name="Copy"
        i18n-name="@@copy"
        value="copy"
        classNames="h-[40px] min-w-[110px] rounded-xl border-primary bg-white text-primary hover:bg-primary hover:text-white whitespace-nowrap"
        (clickEmit)="onCopy()"
      ></app-button-icon-ui>
      <app-button-icon-ui
        buttonType="button"
        icon="print"
        name="Print"
        i18n-name="@@print"
        value="print"
        classNames="h-[40px] min-w-[110px] rounded-xl border-primary bg-white text-primary hover:bg-primary hover:text-white whitespace-nowrap"
        (clickEmit)="onPrint()"
      ></app-button-icon-ui>
    </div>
    <div class="footer-actions-right">
      <app-button-icon-ui
        buttonType="button"
        name="Close"
        i18n-name="@@close"
        value="close"
        classNames="h-[40px] min-w-[110px] rounded-xl border-error bg-white text-error hover:bg-error hover:text-white whitespace-nowrap"
        (clickEmit)="close()"
      ></app-button-icon-ui>
      <app-button-icon-ui
        *ngIf="showAcknowledgmentButton"
        buttonType="button"
        icon="done"
        name="I Acknowledge & Agree to this Policy"
        i18n-name="@@acknowledgeAndAgree"
        value="acknowledge"
        classNames="h-[40px] rounded-xl border-primary bg-primary px-5 text-white hover:bg-primary/90 whitespace-nowrap"
        (clickEmit)="onAcknowledge()"
      ></app-button-icon-ui>
    </div>
  </div>
</div>
